module.exports = __webpack_public_path__ + "img/Image -2.9961e3c6.svg";